import type { Theme } from "@mui/material/styles";
import type { AppDashboardQueriesPageStyles } from "../types";

export function buildDashboardQueriesPageStyles(theme: Theme): AppDashboardQueriesPageStyles {
  return {
    editRoot: {
      display: "flex",
      flexDirection: "column",
      gap: 1.25,
    },
    editHeaderRow: {
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { sm: "center" },
      justifyContent: "space-between",
      gap: 1.25,
    },
    editActionsRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: 0.75,
    },
    editSection: {
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.25,
      p: { xs: 1.25, md: 1.5 },
      bgcolor: "background.paper",
    },
    editSectionTitle: {
      fontWeight: 700,
      mb: 0.35,
    },
    editSectionHint: {
      display: "block",
      mb: 1,
    },
    editErrorAlert: {
      mb: 0,
    },
    editLoadingBox: {
      display: "flex",
      justifyContent: "center",
      py: 4,
    },
    listCreateButton: {
      mr: 1,
    },
  };
}
